import React, { useState, useEffect, useRef } from "react";
import { WarningModal, Layout, Container, Header } from "../components-layout";
import Cookies from "universal-cookie";
import BusquedaAlumnos from "../tools/BusquedaAlumnos";

import { useSelector } from "react-redux";
import {
  CheckCircleIcon,
  ExclamationCircleIcon,
  AcademicCapIcon,
} from "@heroicons/react/24/outline";
import {
  Button,
  ComboNormal,
  InputDate,
  InputNumerText,
  Tr,
  SedesCirculos,
} from "./components";
import { getFechaActual } from "../tools/ConversionFechas";
import { get, post } from "../asignacion-horario/services/General.service";
import {
  handleClick,
  handleEditar,
  handleDate,
} from "./handlers";

import ResultadoDataGrid from "../tools/CustomDataGrid";

import { Alumno, EditarAlumno, Tutor, EditarTutor, Inscripcion } from "./forms";
import { formatearFechaGuiones, formatearFechaHoraGuiones } from "../tools/ConversionFechas";
import { fetchApi } from "../tools";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const PerfilAlumnoIndex = () => {

  const cookies = new Cookies();
  const { headersAPI: headers } = useSelector((state) => state.url); // Headers para enviar al api viene de redux
  const url = cookies.get("__urlSchoolApi"); // url para enviar al api viene de cookies
  const user = useSelector((state) => state.auth.user);
  const IdEmp = useSelector((state) => state.auth.IdEmp);
  const sede = useSelector((state) => state.auth.IdSede);

  const userObj = JSON.parse(user);

  const columnasNormal = [
    { name: "Carnet", id: 1, type: "text", resaltado: false },
    { name: "Alumno", id: 2, type: "text", resaltado: false },
    //{ name: "Carrera", id: 1, type: "text", resaltado: false },
    { name: "Sede", id: 6, type: "text", resaltado: false },
    { name: "Ciclo", id: 3, type: "text", resaltado: false },
    { name: "Grado", id: 5, type: "text", resaltado: false },
    //{ name: "Condición actual", id: 28, type: "text", resaltado: false },
    {
      name: "Perfil",
      id: 999,
      type: "text",
      resaltado: false,
      text: "Consultar",
      alt: "Consultar",
    },
  ];

  const campos = [
    { name: "Alumno", type: "text", position: "", flag: "Aspirante", id: 1 },
  ];

  const columnasCuotas = [
    //{ name: "Carnet", id: 0, type: "text", resaltado: false },
    { name: "Cargo", id: 1, type: "unido", resaltado: false },
    //{ name: "Ciclo", id: 2, type: "text", resaltado: false },
    { name: "Vence", id: 3, type: "text", resaltado: false },
    { name: "Saldo", id: 4, type: "number", resaltado: false },
  ];

  const busquedaRef = useRef()
  const [flagSearch, setFlagSearch] = useState("Aspirante") // para busqieda por campo especifico Aspirante, Carnet
  const [columnas, setColumnas] = useState(columnasNormal);
  const [ciclo, setCiclo] = useState("");
  const [niveles, setNiveles] = useState([]);
  const [ip, setIp] = useState()
  const [grados, setGrados] = useState([]);
  const [secciones, setSecciones] = useState([]);
  const [titulo, setTitulo] = useState("");
  const [rawData, setRawData] = useState([]);
  const [sedes, setSedes] = useState([]);
  const [esCodigovalido, setEsCodigoValido] = useState(false);
  const refSeccion = useRef(null);
  //const sedesRef = useRef(null);
  const [idSede, setIdSede] = useState("01");
  const [todos, setTodos] = useState([]);
  const [opcion, setOpcion] = useState("");
  const [clickeable, setClickeable] = useState(false);
  const [loading, setLoading] = useState(false);
  const [controlesBloqueados, setControlesBloqueados] = useState(false);
  
  const [cuotasPendientes, setCuotasPendientes] = useState([])
  const [fechaActual] = useState(getFechaActual());
  const [editando, setEditando] = useState(false);
  const [errors, setErrors] = useState(true);// false para ocultar el boton
  const [editandoTutor, setEditandoTutor] = useState(false);
  const [tryToSave, setTryToSave] = useState(true)
  const [ableToSave, setAbleToSave] = useState(true)
  const [values, setValues] = useState({});
  const [showGrid, setShowGrid] = useState(true);
  const [resetForm, setresetForm] = useState(false);
  const [modal, setModal] = useState({
    ok: false,
    show: false,
    msg: "",
  });

  const callNiveles = async (idsede) => {
    const data = await fetchApi({
      url: `${url}/utils/busquedas`,
      headers: headers,
      content: {
        opcion: "NIVELES",
        Idsede: idsede,
      },
    });
    setNiveles(data);
  };

  const [filterData, setFilter] = useState([]);
  const handleQuery = (values) => {
    doSearch(values.query.trim());
    setCurrentPage(1);
  };

  const searchParams = ["Carnet", "NombreCompleto"];
  const doSearch = (query) => {
    if (query === null) {
      setFilter(rawData);
    } else {
      setFilter(
        rawData.filter((x) => {
          return searchParams.some((y) => {
            return (
              x[y]?.toString().toLowerCase().indexOf(query.toLowerCase()) > -1
            );
          });
        })
      );
    }
  };
    //Paginación Productos
    const [currentPage, setCurrentPage] = useState(1);
    const recordsPerPage = 12;
  
    const indexOfLastRecord = currentPage * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  
    const currentRecords = filterData?.slice(
      indexOfFirstRecord,
      indexOfLastRecord
    );
  
    const nPages = Math.ceil(filterData?.length / recordsPerPage);
    //Fin paginación Productos
    const handleAlumnoCuotas = (alumno, text) => {
      console.log(alumno, text)
    }

    const handleAlumnoCta = (alumno, text) => {
      setEditandoTutor(false)
      setShowGrid(false)
      setValues({...values, Carnet: alumno.Carnet})
      getDatosAlumno(alumno.Carnet)
    }
  
    useEffect(() => {
      setIdSede(sede);
      //sedesRef.current.value = sede;
      callNiveles(idSede);
    }, [sedes]);

  const callCiclo = async () => {
    const data = await fetchApi({
      url: `${url}/utils/busquedas`,
      headers: headers,
      content: {
        opcion: "CICLO_ACTUAL",
      },
    });
    setCiclo(data[0].Ciclo);
  };

  const bloquear = () => {
    setControlesBloqueados(true);
  };
  const callSedes = async (idgrado) => {
    const data = await fetchApi({
      url: `${url}/utils/busquedas`,
      headers: headers,
      content: {
        opcion: "SEDES",
        Idsede: idSede,
        idgrado: idgrado,
      },
    });
    setSedes(data);
  };

  //////////

  const generos = [
    { id: "M", nombre: "Masculino" },
    { id: "F", nombre: "Femenino" },
  ];
  const estados = [
    { id: "Casado", nombre: "Casado" },
    { id: "Soltero", nombre: "Soltero" },
  ];

  const getDatosAlumno = async(carnetParam) => {
    const data = await get(url + "/perfilalumno/perfil", headers, { Carnet: carnetParam })
    console.log(data)
    if(!data){
      console.log(data)
      setModal({
        ok: false,
        show: true,
        msg: "El alumno seleccionado no tiene datos",
      })
      setValues({})
      setCuotasPendientes([])
    }else{
      getCuotasPendientes(data.msg[0]['Carnet'])
      setValues({
        Carnet: data.msg[0]['Carnet'],
        NombreCompletoAlumno: data.msg[0]['NombreCompletoAlumno'],
        GeneroAlumno: data.msg[0]['GeneroAlumno'],
        IdCiclo:      data.msg[0]['IdCiclo'],
        FechaNac:     data.msg[0]['FechaNac'],
        Direcc:       data.msg[0]['Direcc'],
        Grado:        data.msg[0]['Grado'],
        Ubicacion:    data.msg[0]['Ubicacion'],
        Sede:         data.msg[0]['Sede'],
        CIP:          data.msg[0]['CIP'],
        fotosWeb:     data.msg[0]['fotosWeb'],
        EstadoActual: data.msg[0]['EstadoActual'],
        EstadoMED:    data.msg[0]['EstadoMED'],
        IdFamilia:    data.msg[0]['IdFamilia'],
        FechaEntregaPapeleria: formatearFechaGuiones(data.msg[0]['FechaEntregaPapeleria']),
        Solvencia:       data.msg[0]['Solvencia'],
        GeneroEncargado: data.msg[0]['GeneroEncargado'],
        E_Nombres:       data.msg[0]['E_Nombres'],
        E_Apellidos:     data.msg[0]['E_Apellidos'],
        E_Direcc:        data.msg[0]['E_Direcc'],
        E_Edad:          data.msg[0]['E_Edad'],
        E_EstadoCiv:     data.msg[0]['E_EstadoCiv'],
        E_DPI:     data.msg[0]['E_DPI'],
        E_TelCasa: data.msg[0]['E_TelCasa'],
        E_TelTrab: data.msg[0]['E_TelTrab'],
        E_Ocupa:   data.msg[0]['E_Ocupa'],
        NombreDoc: data.msg[0]['NombreDoc'],
        NitDoc:       data.msg[0]['NitDoc'],
        E_Cel:        data.msg[0]['E_Cel'],
        E_Cel2:       data.msg[0]['E_Cel2'],
        E_Mail:       data.msg[0]['E_Mail'],
        EmailT:      data.msg[0]['EmailT'],
        EmailT2:     data.msg[0]['EmailT2'],
        CelEnvioSMS:  data.msg[0]['CelEnvioSMS'],
        CelEnvioSMS2: data.msg[0]['CelEnvioSMS2'],
        NombreCompletoEncargado: data.msg[0]['NombreCompletoEncargado'],
        ColAutorizada:    data.msg[0]['ColAutorizada'],
        ColDescuento:     data.msg[0]['ColDescuento'],
        ColPaga:          data.msg[0]['ColPaga'],
        InsAutorizada:    data.msg[0]['InsAutorizada'],
        InsDescuento:     data.msg[0]['InsDescuento'],
        InsPaga:          data.msg[0]['InsPaga'],
        Solicitud:        data.msg[0]['Solicitud'],
        FechaInscripcion: data.msg[0]['FechaInscripcion'] /*formatearFechaHoraGuiones(data.msg[0]['FechaInscripcion'])*/,
        PersonaInscribio: data.msg[0]['PersonaInscribio'],
        Movil1: data.msg[0]['Movil1'],
        Movil2: data.msg[0]['Movil2'],
        Movil3: data.msg[0]['Movil3'],
        Cuotas: data.msg[0]['Cuotas'],
        FacilidadesPago: data.msg[0]['FacilidadesPago'],
        UltimoPago: data.msg[0]['UltimoPago'],
        UltimaCuota: data.msg[0]['UltimaCuota'],
        UltimoCiclo: data.msg[0]['UltimoCiclo'],
        P_NombreCompleto : data.msg[0]['P_Nombres'] + ' ' + data.msg[0]['P_Apellidos'],
        P_Cel: data.msg[0]['P_Cel'],
        P_Mail: data.msg[0]['P_Mail'],
        M_NombreCompleto : data.msg[0]['M_Nombres'] + ' ' + data.msg[0]['M_Apellidos'],
        M_Cel: data.msg[0]['M_Cel'],
        M_Mail: data.msg[0]['M_Mail'],
      })
    }
  }
  
  const getCuotasPendientes = async (carnetParam) => {
    const response = await get(url + "/perfilalumno/perfil", headers, {
      Carnet: carnetParam,
      Opcion: "CUOTAS_PENDIENTES"
    })
    setCuotasPendientes(response.msg)
  }

  useEffect(() => {
    console.log('Hay errores?', errors)
  }, [errors])

  const verDatosTipo = (opcion = "Todos") => {
    setCurrentPage(1);
    setOpcion(opcion);
    // usar el titulo para agregar el envio del codigo
    const opciones = {
      Todos: () => {
        setRawData([...todos]);
        setFilter([...todos]);
        setColumnas(columnasNormal);
        setEsCodigoValido(true);
      },
    };
    opciones[opcion]();
  };

  useEffect(() => {
    verDatosTipo();
  }, [todos]);

  const getIp = async() => {
    const response = await fetch("https://ipapi.co/json")
    const json = await response.json()
    console.log(json)
    setIp(json.ip)
  }

  const handleInicio = (tipo) => {
    // si es texto cambia Aspirante, 
    // else Carnet
    if(/[0-9]/.test(tipo)){
      setFlagSearch("Carnet")
    }else{
      setFlagSearch("Aspirante")
    }
  }

  useEffect(() => {
    getIp()
    callCiclo();
    callSedes();
    setTitulo("Alumnos del ciclo actual")
  }, []);

  return (
    <>
      <WarningModal
        open={loading ? true : false}
        image={<img src="./img/loader.gif" alt="loading" />}
        opacity="bg-opacity-100"
      />
      <WarningModal
        width={"sm:w-full sm:max-w-sm"}
        open={modal.show ? true : false}
        image={
          modal.ok ? (
            <CheckCircleIcon className="h-20 w-20 text-green-500 mx-auto" />
          ) : (
            <ExclamationCircleIcon className="h-20 w-20 text-red-500 mx-auto" />
          )
        }
        title={"Aviso"}
        subtitle={<span>{modal.msg}</span>}
        opacity="bg-opacity-50"
      >
        <div className="mt-5 sm:mt-6">
          <button
            onClick={() => {
              if (modal.reload) {
                window.location.reload();
              }
              setModal((curr) => ({
                ...curr,
                show: false,
                reload: false,
              }));
            }}
            type="button"
            className="inline-flex w-full justify-center rounded-md border border-transparent bg-azulBrillanteMira px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-secundario transition duration-500 ease focus:outline-none sm:text-sm"
          >
            Entendido
          </button>{" "}
        </div>
      </WarningModal>
      <Layout userObj={userObj} activeTab="Alumnos">
        <Container height="h-full">
          <Header title="Perfil de alumno" logo={AcademicCapIcon} />
          {showGrid?
          <>
          
          <div className="flex flex-col md:flex-row ">
              
              <div className="w-full m-2 p-2 rounded-lg px-2 py-2 grid grid-cols-1  bg-secundarioMira shadow-sm shadow-white">
                    <BusquedaAlumnos
                    handleInicio={handleInicio}
                    url={url + "/utils/busquedas"}
                    headers={headers}
                    setModal={setModal}
                    metodo={"ALUMNOS_V2"}
                    opcion={"opcion"}
                    campos={campos}
                    columnas={columnas}
                    titulo={"Resultados"}
                    subtitulo={"Listado que coinciden con tu búsqueda"}
                    seleccion={true}
                    reg_pag={20}
                    Idsede={"Idsede"}
                    handleAlumnoCta={handleAlumnoCta}
                    dataAlumnos={currentRecords}
                    perfil={true}
                    setFlagSearch={setFlagSearch}
                    flagSearch={flagSearch}
                    busquedaRef={busquedaRef}
                    />
              </div>
            </div>
          </>
          :
          <div className="flex justify-end flex-col gap-2">

            <div className="flex flex-row justify-end">
              <button
                name={"cancelar"}
                onClick={()=> setShowGrid(true)}
                className="/inline-flex justify-center rounded-md border border-transparent bg-azulBrillanteMira px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-secundario transition duration-500 ease focus:outline-none sm:text-sm"
                >{ "Buscador" }</button>
            </div>
            <div className="flex  w-full  bg-primarioMira flex-col /shadow-white shadow-sm p-2 rounded-md mx-auto">
            
              {editando ? (
                <EditarAlumno
                  values={values}
                  setValues={setValues}
                  generos={generos}
                  handleDate={handleDate}
                />
              ) : (
                <Alumno
                  values={values}
                  setValues={setValues}
                  generos={generos}
                  handleDate={handleDate}
                  getDatosAlumno={getDatosAlumno}
                />
              )}
              <div className="grid grid-cols-5 /bg-red-200 mt-2">
                <div
                  className={classNames(
                    editando ? "justify-between" : "justify-end",
                    "flex grid-flow-row col-start-5 col-end-5 pl-2"
                  )}
                >
                  {editando ? (
                    [
                      <Button
                        cmdLabel="Cancelar"
                        cmdName="cancelarAlumno"
                        cmdSetter={setEditando}
                        cmdAction={handleClick}
                      />,
                      <Button
                        cmdLabel="Actualizar"
                        cmdName="guardarAlumno"
                        cmdSetter={setEditando}
                        cmdAction={handleClick}
                      />,
                    ]
                  ) : null
                  
                  }
                </div>
              </div>
            </div>
            <div className="flex flex-col">
              
              <div className="flex w-full flex-row /shadow-white shadow-sm p-2 rounded-md mx-auto bg-primarioMira gap-2 ">
                <div className="flex flex-col w-1/2 text-white bg-secundarioMira p-2 rounded-md gap-2">
                <p className="text-azulBrillanteMira text-xl font-medium">Información de pagos</p>

                <div className="flex flex-row w-full justify-around bg-primarioMira p-2 rounded-md my-auto h-1/2 gap-2">
                  <div className="flex flex-col my-auto">
                    <p className="text-gray-400"><p className="font-medium text-white">Cuotas:  </p>{values.Cuotas}</p>
                  </div>
                  <div className="flex flex-col my-auto">
                    <div className="text-gray-400">
                      <p className="font-medium text-white">Facilidad de pago:  </p>
                      <p className={classNames(values.FacilidadesPago? "bg-green-500":"bg-red-500", "text-white p-1 rounded-md text-center")}>
                       {values.FacilidadesPago || "No aplicó"}
                      </p>
                    </div>
                  </div>
                  <div className="flex flex-col my-auto">
                    <p className="text-gray-400"><p className="font-medium text-white">Último pago realizado:  </p>{values.UltimoPago}</p>
                  </div>
                  <div className="flex flex-col my-auto">
                    <p className="text-gray-400"><p className="font-medium text-white">Última cuota pagada:  </p>{values.UltimaCuota}</p>
                  </div>
                </div>
                  <Inscripcion values={values} setValues={setValues} handleDate={handleDate}/>
                </div>
                <div className="flex flex-col w-1/2 justify-between bg-secundarioMira rounded-md p-2">
                <p className="text-azulBrillanteMira text-xl  font-medium">Cuotas pendientes</p>
                {
                  cuotasPendientes.length > 0 ?
                  
                  <ResultadoDataGrid
                      headers={headers}
                      setModal={setModal}
                      columnas={columnasCuotas}
                      alumnos={cuotasPendientes}
                      handleAlumno={handleAlumnoCuotas}
                      titulo={""}
                      subtitulo={""}
                      seleccion={true}
                      />
                      
                  :
                <div className="text-center flex flex-col m-auto">
                  <CheckCircleIcon className=" text-green-500 h-[50%] w-[50%] /inline mx-auto"></CheckCircleIcon>
                  <p className="text-white text-xl">No se encontraron cuotas pendientes</p>

                </div>
                }
              </div>
              
            </div>

            </div>
            <div className="hidden /flex  w-full flex-col shadow-white shadow-sm p-2 rounded-md mx-auto">
              {editandoTutor ? (
                <EditarTutor
                  values={values}
                  setValues={setValues}
                  generos={generos}
                  handleDate={handleDate}
                  setErrors={setErrors}
                  estados={estados}
                  tryToSave={tryToSave}
                />
              ) : (
                <Tutor
                  values={values}
                  setValues={setValues}
                  generos={generos}
                  handleDate={handleDate}
                />
              )}
              <div className="grid grid-cols-5 /bg-red-200 mt-2">
                <div
                  className={classNames(
                    editandoTutor ? "justify-between" : "justify-end",
                    "flex grid-flow-row col-start-5 col-end-5 pl-2"
                  )}
                >
                  {editandoTutor ? (
                    [
                      <Button
                        cmdLabel="Cancelar"
                        cmdName="cancelarTutor"
                        cmdSetter={setEditandoTutor}
                        cmdAction={handleClick}
                      />,
                      <Button
                        cmdLabel="Actualizar"
                        cmdName="guardarTutor"
                        cmdSetter={setEditandoTutor}
                        cmdAction={handleClick}
                      />,
                    ]
                  ) : null
                  }
                </div>
              </div>
            </div>
            <div className="hidden /flex  w-full flex-col shadow-white shadow-sm p-2 rounded-md mx-auto">
              
              <div className="flex justify-between mt-4">

                {!errors && 
                <Button
                  cmdLabel="Guardar"
                  cmdName="guardarDatos"
                  cmdSetter={setModal}
                  dataValues={values}
                  url={url + '/perfilalumno/perfil'}
                  headers={headers}
                  api={post}
                  IdEmp={IdEmp}
                  setTryToSave={setTryToSave}
                  setAbleToSave={setAbleToSave}
                  ableToSave={ableToSave}
                  cmdAction={handleClick}//{values:values, setter:setModal, name:"guardarDatos", headers:headers, url: url}
                  ip={ip}
                  setLoading={setLoading}
                  setShowGrid={setShowGrid}
                  />
                }
              </div>
            </div>
          </div>}
        </Container>
      </Layout>
    </>
  );
};

export default PerfilAlumnoIndex;
